module.exports = __webpack_public_path__ + "img/merge.e36e89d6.jpg";